export const BREADCRUMB_ITEMS = [
  {
    href: '/',
    id: 2,
    label: 'Home',
  },
];

export const NOT_FOUND_METADATA = { description: '404', title: '404' };
